import { Text, type TextStyleOptions } from "pixi.js";
import { LocalizedText } from "@slot/game-shell";
import type { LocalizationService } from "@slot/game-shell";

const FONT = "Roboto, system-ui, sans-serif";

/**
 * The panels' type, after the purchase card in the art (`bonus purchase layout example.png`): orange headings on a dark
 * orange outline, purple amounts on a white one, brown body text on the card's cream.
 */
export const CANDY_TEXT = {
  heading: { fontFamily: FONT, fontWeight: "900", fill: 0xffa41b, stroke: { color: 0xa03c00, width: 10, join: "round" }, align: "center" },
  amount: { fontFamily: FONT, fontWeight: "900", fill: 0x9b2fe0, stroke: { color: 0xffffff, width: 14, join: "round" }, align: "center" },
  body: { fontFamily: FONT, fontWeight: "700", fill: 0x7a4a2a, align: "center" },
  bigWinTitle: {
    fontFamily: FONT,
    fontWeight: "900",
    fill: 0xffdd33,
    stroke: { color: 0xc2410c, width: 16, join: "round" },
    dropShadow: { color: 0x3b0a00, alpha: 0.6, blur: 8, distance: 6, angle: Math.PI / 2 },
    align: "center",
  },
  bigWinAmount: {
    fontFamily: FONT,
    fontWeight: "900",
    fill: 0xffffff,
    stroke: { color: 0x9b2fe0, width: 16, join: "round" },
    dropShadow: { color: 0x2a0050, alpha: 0.6, blur: 8, distance: 6, angle: Math.PI / 2 },
    align: "center",
  },
} as const satisfies Record<string, TextStyleOptions>;

/** A localized line of the panel's type, centred at `y`, shrunk to `box` when a language runs long. */
export function candyLabel(input: {
  localization: LocalizationService;
  key: string;
  fallback: string;
  style: TextStyleOptions;
  fontSize: number;
  y: number;
  box: { width: number; height: number };
  label: string;
}): LocalizedText {
  const text = new LocalizedText({
    localization: input.localization,
    key: input.key,
    fallback: input.fallback,
    style: { ...input.style, fontSize: input.fontSize },
    label: input.label,
    fitBox: input.box,
  });
  text.position.set(0, input.y);
  return text;
}

/** A line whose string the panel sets (amounts, counts), centred at `y`. */
export function candyValue(input: { style: TextStyleOptions; fontSize: number; y: number; label: string }): Text {
  const text = new Text({ text: "", style: { ...input.style, fontSize: input.fontSize }, label: input.label });
  text.anchor.set(0.5);
  text.position.set(0, input.y);
  return text;
}
